// src/utils/useMessage.tsx
'use client';

import React, { ReactNode } from 'react';
import { App } from 'antd';

// type Types = 'success' | 'error' | 'neutral';

export const useMessageC = () => {
  const appContext = App.useApp();
  const message = appContext?.message;
  const messageC = (text
  // type?: Types,
  : string | ReactNode) => {
    try {
      if (!message) {
        console.warn('message context not available');
        return;
      }
      message.open({
        key: 'z',
        duration: 3,
        className: 'custom-message-no-bg',
        style: {
          background: 'transparent',
          padding: 0,
          boxShadow: 'none'
        },
        content: React.createElement('div', {
          style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: '#F48A8A',
            padding: '8px 12px',
            borderRadius: '8px',
            color: '#ffffff'
          }
        }, React.createElement('span', {
          style: {
            color: '#ffffff'
          }
        }, text))
      });
    } catch (e) {
      console.error('useMessageC error:', e);
    }
  };
  return messageC;
};